function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import App from 'modules/App';
import Link from 'components/Link';
import Locked from 'svg/locked.svg';
import UnLocked from 'svg/unlocked.svg';
import styles from './Locked.pcss';
var _React_PureComponent;
class LockedComponent extends (_React_PureComponent = React.PureComponent) {
    onLockedClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick();
    }
    renderIcon() {
        const { isLocked } = this.props;
        return isLocked ? /*#__PURE__*/ _jsx(Locked, {}) : /*#__PURE__*/ _jsx(UnLocked, {});
    }
    renderLabel() {
        const { isLocked } = this.props;
        const lockState = isLocked ? 'locked' : 'unlocked';
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels[lockState]));
    }
    render() {
        return /*#__PURE__*/ _jsxs(Link, {
            to: "",
            className: styles.locked,
            onClick: (e)=>this.onLockedClick(e),
            children: [
                this.renderIcon(),
                this.renderLabel()
            ]
        });
    }
}
_define_property(LockedComponent, "propTypes", {
    // Explicit props
    isLocked: PropTypes.bool,
    onClick: PropTypes.func
});
_define_property(LockedComponent, "defaultProps", {
    isLocked: false,
    onClick: ()=>{}
});
export default withStyles(styles)(LockedComponent);
